module.exports = __webpack_public_path__ + "static/media/4-b.d6cf8a8e.jpg";